import AuthenticationService from './../../services/AuthenticationService'
import alerts from '@/alerts/alert'
import Store from '@/store'
import confirmations from './confirmations'

const employee = {
  namespaced: true,
  state: {
    loading: false,
    modal: false,
    employees: [],
    label: 'Create',
    form: {},
    datas: {},
    data: [],
    queryParam: null
  },
  getters: {
    getData (state) {
      return state.employees
    }
  },
  mutations: {
    SET_NULL_FORM (state, data) {
      state.form = {
        branch_id: null,
        company_id: null,
        NIK: null,
        first_name: null,
        last_name: null,
        nick_name: null,
        address: null,
        province_id: null,
        city_id: null,
        district_id: null,
        village_id: null,
        postal_code: null,
        phone_number: null,
        email: null,
        other_phone_number: null,
        maritial_status: null,
        religion: null,
        identity_type: null,
        identity_number: null,
        npwp_number: null,
        family_card_number: null,
        bpjs_kesehatan_number: null,
        jkn_number: null,
        medical_facility_number: null,
        blood_type: null,
        birth_place: null,
        birth_date: null,
        gender: null,
        unit_id: null,
        job_title_id: null,
        job_position_id: null,
        employee_status: null,
        join_date: null,
        end_date: null,
        end_contract_date: null,
        working_periode: null,
        emergency_contact_person: null,
        emergency_contact_number: null,
        education: null,
        bank_id: null,
        bank_account: null,
        bank_number: null,
        non_formal_education: null,
        certificate: null,
        coordinate: null,
        images: null,
        active: null
      }
    },
    SET_DATA_EMPLOYEE (state, data) {
      state.employees = data
    },
    SET_DATAS (state, data) {
      state.datas = data
    },
    SET_DATA (state, data) {
      state.data = data
    },
    SET_FORM (state, data) {
      state.form = data
    },
    SET_LABEL (state, data) {
      state.label = data
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_QUERY_PARAM (state, data) {
      state.queryParam = data
    }
  },
  actions: {
    async all ({ commit }, payload) {
      commit('SET_LOADING', payload)
      return await AuthenticationService.get('employees/all').then(({ data }) => {
        commit('SET_DATA_EMPLOYEE', data.data)
        commit('SET_LOADING', false)
      })
    },
    // async paginate ({ commit, state }, payload) {
    //   commit('SET_LOADING', payload.loading)
    //   state.queryParam = payload.datas
    //   return await AuthenticationService.get('employees/paginate?' + utils.convertObjectToQueryString(state.queryParam)).then(({ data }) => {
    //     commit('SET_DATAS', data.data)
    //     commit('SET_DATA', data.data.data)
    //     commit('SET_LOADING', false)
    //   })
    // },
    async paginate ({ commit }, payload) {
      commit('SET_LOADING', payload.loading)
      commit('SET_QUERY_PARAM', payload.datas)
      return await AuthenticationService.get('employees/paginate?' + payload.datas).then(({ data }) => {
        commit('SET_DATAS', data.data)
        commit('SET_DATA', data.data.data)
        commit('SET_LOADING', false)
      })
    },
    onRefresh ({ state }) {
      Store.dispatch('employee/paginate', { loading: true, datas: state.queryParam })
    },
    async setActive ({ commit, state }, payload) {
      const params = {
        id: payload[1],
        active: payload[0]
      }
      return await AuthenticationService.put('employees/set-active/' + payload[1], params).then(({ data }) => {
        commit('SET_LOADING', false)
        console.log(JSON.stringify(data))
        alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
      })
    },
    getCity  ({ state }) {
      Store.dispatch('cities/all', state.form.province_id)
    },
    getDistrict  ({ state }) {
      Store.dispatch('districts/all', state.form.city_id)
    },
    getVillage  ({ state }) {
      Store.dispatch('villages/all', state.form.district_id)
    },
    onInputImage ({ state }, payload) {
      state.form[payload[1]] = payload[0]
    },
    confirmationSave () {
      confirmations.confirmationForm('employee/save')
    },
    async save ({ commit, state }) {
      try {
        if (state.label === 'Create') {
          Store.dispatch('loading/setLoading', true)
          return await AuthenticationService.post('employees/create', state.form).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            Store.dispatch('employee/paginate', { datas: state.queryParam })
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'Update') {
          Store.dispatch('loading/setLoading', true)
          return await AuthenticationService.post('employees/update/' + state.form.id, state.form).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            if (data.code === 200) {
              state.modal = false
              Store.dispatch('employee/paginate', { datas: state.queryParam })
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'AutoUpdate') {
          return await AuthenticationService.post('employees/update/' + state.form.id, state.form).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            if (data.code === 200) {
              const index = state.employees.findIndex(item => item.id === state.form.id)
              state.employees.splice(index, 1)
              Store.dispatch('employee/paginate', { datas: state.queryParam })
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'Delete') {
          return await AuthenticationService.delete('employees/delete/' + state.form.id).then(({ data }) => {
            Store.dispatch('loading/setLoading', true)
            if (data.code === 200) {
              const index = state.branches.findIndex(item => item.id === state.form.id)
              state.employees.splice(index, 1)
              Store.dispatch('employee/paginate', { datas: state.queryParam })
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        }
      } catch (error) {
        Store.dispatch('loading/setLoading', false)
        alerts.sweetalertToast('error', error.message)
      }
    },
    onAction ({ commit, state }, payload) {
      commit('SET_LABEL', payload[1])
      commit('SET_FORM', payload[0])
      if (payload[1] === 'Delete') {
        confirmations.confirmationDelete('employee/save')
      } else if (payload[1] === 'AutoUpdate') {
        confirmations.confirmationForm('employee/save')
      } else {
        state.modal = true
        if (payload[1] === 'Update' && state.form.province_id > 0) {
          Store.dispatch('branches/getCity')
          if (payload[1] === 'Update' && state.form.city_id > 0) {
            Store.dispatch('branches/getDistrict')
            if (payload[1] === 'Update' && state.form.district_id > 0) {
              Store.dispatch('branches/getVillage')
            }
          }
        }
      }
      // state.modal = true
      // commit('SET_LABEL', payload[1])
      // commit('SET_FORM', payload[0])
      // if (payload[1] === 'Update' && state.form.province_id > 0) {
      //   Store.dispatch('employee/getCity')
      //   if (payload[1] === 'Update' && state.form.city_id > 0) {
      //     Store.dispatch('employee/getDistrict')
      //     if (payload[1] === 'Update' && state.form.district_id > 0) {
      //       Store.dispatch('employee/getVillage')
      //     }
      //   }
      // }
    }
  }
}

export default employee
